import React, { useState, useEffect } from 'react';
import './modal.css';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import PearsonLogo from '../../../images/pearson_logo.png';
import iconFolder from '../../../images/icon_folder.gif';
import fileIcon from '../../../images/icon_file.gif'; 
import '../../common/css/pw_push5.css';
import { getSubDirectories, resetBulkUploadStateManageMent } from '../../Dashboard/actions';
import { updateGenricSuccessMessageToEmpty } from '../../User/actions';
import '../../common/css/downloadprogressbar.css';
import '../css/bulkrename.css';
import apiService from '../../utils/apiService';
import { getCurrentPathFromLocation } from '../../utils/pathUtils';
import {
  FILENAME_TOO_LONG_MESSAGE,
  getFileNameAndExtension,
  getRenameApiErrorMessage,
  isFilenameTooLong,
  MAX_FILENAME_LENGTH,
} from './renameFolderHelpers';
import { useSoftDeletedNames } from './useSoftDeletedNames';
import {
  USER_DISPLAY_MSG,
  DISALLOWED_FILE_NAME_CHAR_REGEX,
  DISALLOWED_FILE_NAME_CHAR_MESSAGE,
  stripDisallowedFileNameChars,
  shouldBlockFileNameKeyEvent,
} from '../../../Constants';

const BulkRenamePopup = (props) => {
  const [filesLists, setFilesList] = useState([]);
  const [renamefilesLists, setRenameFileList] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [renamedItems, setRenamedItems] = useState([]);
  const [modalHeight, setModalHeight] = useState('85%');
 
  const dispatch = useDispatch();
  const location = useLocation();
  const currentPath = getCurrentPathFromLocation(location.pathname);
  const directoriesList = useSelector(state => state.directoriesReducer.serverResponse);
  const renameFileLimitMsg = useSelector(state => state.UserReducer.userSuccessMessage);
  const closeBulkRenamePopup = useSelector(state => state.directoriesReducer.closeDownloadPopup);
  const [renameErrMsg, setRenameErrMsg] = useState("");
  const [renameFolderErrMsg, setRenameFolderErrMsg] = useState('');
  const softDeletedNames = useSoftDeletedNames(currentPath);
  let changedItems;
 
  useEffect(() => {
    if (Object.entries(renameFileLimitMsg).length > 0) {
      dispatch(resetBulkUploadStateManageMent({}));
    }
  }, [renameFileLimitMsg]);
 
  useEffect(() => {
    if (closeBulkRenamePopup?.status_code === 200) {
      props.onModalPopupStateChange(props.displayModal);
    }
    dispatch(resetBulkUploadStateManageMent({}));
  }, [closeBulkRenamePopup]);
 
  useEffect(() => {
    dispatch(updateGenricSuccessMessageToEmpty({}));
    setFilesList(directoriesList?.data);
    setRenameFileList(directoriesList?.data);
  }, [directoriesList]);
 
  useEffect(() => {
    dispatch(getSubDirectories({ dir: currentPath }));
  }, [currentPath, dispatch]);

  const closeModal = (e) => {
    e.stopPropagation();
    props.onModalPopupStateChange(props.displayModal);
  };
 
  const closeConfirmModal = (e) => {
    e.stopPropagation();
    //setShowPopup(false);
  };
 
  const handleDirectoryChange = (rowIndex, newValue, isFile) => {
    setRenameFileList((prev) => {
      const updated = [...prev];
      const originalFile = filesLists[rowIndex];
      if (isFile) {
        const { extension } = getFileNameAndExtension(originalFile.directory, { isFile: true });
        updated[rowIndex] = { ...updated[rowIndex], directory: newValue + extension };
      } else {
        updated[rowIndex] = { ...updated[rowIndex], directory: newValue };
      }
      return updated;
    });
  };
 
  const handleBulkRenameClick = () => {
    changedItems = filesLists
      .map((file, index) => ({
        oldname: file.directory,
        newName: renamefilesLists[index]?.directory,
        isFile: file.isFile
      }))
      .filter(item => item.oldname !== item.newName);

    const hasInvalid = changedItems.some(
      (f) =>
        !f.newName ||
        f.newName.trim() === ""
    );

    const hasTooLongName = changedItems.some((f) => isFilenameTooLong(f.newName));

    const hasForbiddenChars = changedItems.some((f) =>
      f.newName && DISALLOWED_FILE_NAME_CHAR_REGEX.test(f.newName)
    );

    // Check for duplicate names in the resulting file list (case-sensitive; full name incl. extension)
    const allFinalNames = renamefilesLists.map(item => item?.directory);
    const duplicateNames = allFinalNames.filter((name, index) =>
      name && allFinalNames.indexOf(name) !== index
    );
    const hasDuplicates = duplicateNames.length > 0;

    if (changedItems.length <= 0) {
      setRenameFolderErrMsg('No changes detected for rename');
    } 
    else if (hasInvalid) {
      setRenameFolderErrMsg('One or more Files/Folder names are empty.');
    } else if (hasForbiddenChars) {
      setRenameFolderErrMsg(DISALLOWED_FILE_NAME_CHAR_MESSAGE);
    } else if (hasTooLongName) {
      setRenameFolderErrMsg(FILENAME_TOO_LONG_MESSAGE);
    } else {
      const uniqueDuplicates = [...new Set(duplicateNames)];
      const softDeletedSet = new Set(softDeletedNames);
      const softDeletedCollisionNames = [
        ...new Set(
          changedItems
            .map((f) => f.newName)
            .filter((n) => n && softDeletedSet.has(n))
        ),
      ];
      const hasSoftDeletedCollisions = softDeletedCollisionNames.length > 0;

      if (hasDuplicates && hasSoftDeletedCollisions) {
        setRenameFolderErrMsg(
          `Duplicate names not allowed: ${uniqueDuplicates.join(', ')}. Duplicate names not allowed as file or folder already exists in the Soft Deleted list : ${softDeletedCollisionNames.join(', ')}`
        );
      } else if (hasDuplicates) {
        setRenameFolderErrMsg(`Duplicate names not allowed: ${uniqueDuplicates.join(', ')}`);
      } else if (hasSoftDeletedCollisions) {// Only softdelete duplicates available
        setRenameFolderErrMsg(
          `Duplicate names not allowed as file or folder already exists in the Soft Deleted list: ${softDeletedCollisionNames.join(', ')}`
        );
      } else {
        setRenameFolderErrMsg('');
        setRenamedItems(changedItems);
        setShowPopup(true);
      }
    }
  };
 
  const autoResize = (el) => {
    if (el) {
      el.style.height = "auto";
      el.style.height = `${el.scrollHeight}px`;
    }
  };

   const handleRenameSubmit = async () => {
  setRenameErrMsg("");
 
  if (!Array.isArray(renamedItems) || renamedItems.length === 0) {
    setRenameErrMsg("No files selected for rename.");
    return;
  }
 
  const changedFiles = renamedItems.filter(f => f.oldname !== f.newName);
  if (changedFiles.length === 0) {
    setRenameErrMsg("No changes detected.");
    return;
  }

  if (changedFiles.some((f) => isFilenameTooLong(f.newName))) {
    setRenameErrMsg(FILENAME_TOO_LONG_MESSAGE);
    return;
  }
 
  // Correct payload with both old and new names
  const payload = {
    data: {
      current_path: currentPath,
      rename_items: changedFiles.map(f => ({
        rename_filename: f.oldname,
        rename_filename_new: f.newName
      })),
    },
  };
 
  console.log("Renaming payload:", payload);
 
  try {
    const response = await apiService.post("rename", payload);
    const data = response?.data;
    console.log("Rename API response:", response);

    const apiError = getRenameApiErrorMessage(data);
    if (apiError) {
      dispatch(updateGenricSuccessMessageToEmpty({}));
      setRenameErrMsg(apiError);
      return;
    }

    dispatch({ type: USER_DISPLAY_MSG, response: data });
    dispatch(getSubDirectories({ dir: currentPath }));
    setShowPopup(false);
    props.onModalPopupStateChange(props.displayModal);
  } catch (error) {
    console.error("Error during rename:", error);
    setRenameErrMsg("Error renaming files.");
  }
};
 
 
  return (
    <>
      {/* Bulk Rename Modal (always open) */}
      <div className="modal" onClick={e => e.stopPropagation()}>{/*{closeModal}> */}
        <div
          className="modal-content-download"
          style={{ height: modalHeight, width: "75%", maxWidth: "700px" }}
          onClick={e => e.stopPropagation()}
        >
          <table border="0" width="100%" cellSpacing="3" cellPadding="0" className='rename_modal-content-table'>
            <tbody>
              <tr align="left" valign="top">
                <td align="left" valign="middle">
                  <span className="pagetitle">&nbsp;Bulk Rename</span>
                </td>
                <td align="right" valign="middle">
                  <img src={PearsonLogo} title="Pearson Education" alt="Pearson Education"
                    width="85" height="21" border="0" />
                </td>
                <td><span className="close" onClick={closeModal}>&times;</span></td>
              </tr>
            </tbody>
          </table>
 
          <div className='table-container-bulkdownload'>
            <table className='myTable' border="1" width="99%" cellSpacing="1" cellPadding="4">
              <tbody>
                <tr>
                  <th>Name</th>
                  <th>Bulk Rename</th>
                </tr>
 
                {filesLists?.map((fileList, index) => {
                  const cellStyle = index % 2 === 0 ? "renamecellWhite" : "renamecellGreen";
                  const folderIcon = fileList.isFile ? fileIcon : iconFolder;
                  const renamedValue = renamefilesLists[index]?.directory || "";
                  const isRenamed = renamedValue !== fileList.directory;
                  
                  const { name: editableName, extension } = getFileNameAndExtension(renamedValue, {
                    isFile: fileList.isFile,
                  });

                  const handleBulkKeyDown = (e) => {
                    if (shouldBlockFileNameKeyEvent(e)) {
                      e.preventDefault();
                      setRenameFolderErrMsg(DISALLOWED_FILE_NAME_CHAR_MESSAGE);
                    }
                  };

                  const handleChange = (e) => {
                    const raw = e.target.value;
                    const cleaned = stripDisallowedFileNameChars(raw);
                    const hadDisallowed = raw !== cleaned;

                    handleDirectoryChange(index, cleaned, fileList.isFile);
                    autoResize(e.target);

                    const allTextAreas = document.querySelectorAll('textarea.renameInput');
                    let anyEmpty = false;
                    let anyTooLong = false;

                    allTextAreas.forEach((textarea, taIndex) => {
                      const baseName =
                        taIndex === index ? cleaned : textarea.value || '';
                      const ext = textarea.dataset.extension || '';

                      if (baseName.trim().length === 0) {
                        anyEmpty = true;
                      }
                      if ((baseName + ext).length > MAX_FILENAME_LENGTH) {
                        anyTooLong = true;
                      }
                    });

                    if (anyEmpty) {
                      setRenameFolderErrMsg('One or more Files/Folder names are empty.');
                    } else if (anyTooLong) {
                      setRenameFolderErrMsg(FILENAME_TOO_LONG_MESSAGE);
                    } else if (hadDisallowed) {
                      setRenameFolderErrMsg(DISALLOWED_FILE_NAME_CHAR_MESSAGE);
                    } else {
                      setRenameFolderErrMsg('');
                    }
                  };

                  return (
                    <tr key={index} className="textalign">
                      <td className={`${cellStyle} originalColumn`}>
                        <div className="folderContainer">
                          <img alt="" src={folderIcon} />
                          <span>{fileList.directory}</span>
                        </div>
                      </td>
                     
                      <td className={`${cellStyle} renameColumn`}>
                          <div className="folderContainer">
                            <img alt="" src={folderIcon} />
                            <textarea
                              value={editableName}
                              onKeyDown={handleBulkKeyDown}
                              onChange={handleChange}
                              rows={1}
                              className={`renameInput ${isRenamed ? "renamed" : ""}`}
                              data-extension={fileList.isFile ? extension : ''}
                              ref={(el) => el && autoResize(el)}
                            />
                            {fileList.isFile && extension && (
                              <span className="file-extension-readonly">{extension}</span>
                            )}
                          </div>
                        </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
 
          {(localStorage.getItem('user.role') !== 'Vendor') &&
            <table width="100%">
              <tbody>
                <tr>
                  <td>
                    <button className="formButtonDownload" onClick={handleBulkRenameClick}>
                      Bulk Rename
                    </button>                   
                  </td>
                  <br/>
                  <td>
                      <span className='create-new-folder-ErrorMsg'>
                          {renameFolderErrMsg}
                      </span>
                  </td>
                </tr>
              </tbody>
            </table>
          }
        </div>
      </div>
 
      {/* Confirmation Modal (on top of rename modal) */}
      {showPopup && (
        <div className="modal" onClick={closeConfirmModal}>
          <div
            className="modal-content-download"
            style={{ width: "50%", maxWidth: "600px", zIndex: 2000 }}
            onClick={(e) => e.stopPropagation()}
          >
            <table
              border="0" width="100%" cellSpacing="3" cellPadding="0" className='rename_modal-content-table'
            >
              <tbody>
                <tr align="left" valign="top">
                  <td align="left" valign="middle">
                    <span className="pagetitle">&nbsp;Confirmation Bulk Rename</span>
                  </td>
                  <td align="right" valign="middle">
                    <img src={PearsonLogo} title="Pearson Education" alt="Pearson Education"
                      width="85" height="21" border="0" />
                  </td>
                  <td><span className="close"  onClick={() => setShowPopup(false)}>&times;</span></td>
                </tr>
              </tbody>
            </table>
 
            <div className="table-container-bulkdownload" style={{ marginTop: "0px", paddingTop: "0px" }}>
              <table
                className='myTable'
                border="1"
                width="99%"
                cellSpacing="1"
                cellPadding="4"
                style={{ marginTop: "0px" }}
              >
                <tbody>
                  <tr>
                    <th>Name</th>
                    <th>Renamed To</th>
                  </tr>
 
                  {renamedItems?.map((item, index) => {
                    const cellStyle = index % 2 === 0 ? "renamecellWhite" : "renamecellGreen";
                    const folderIcon = item.isFile ? fileIcon : iconFolder;
 
                    return (
                      <tr key={index}>
                        <td className={`${cellStyle} originalColumn`}>
                          <div className="folderContainer">
                            <img alt="" src={folderIcon} />
                            <span>{item.oldname}</span>
                          </div>
                        </td>
                        <td className={`${cellStyle} renameColumn`}>
                          <div className="folderContainer">
                            <img alt="" src={folderIcon} />
                            <span>{item.newName}</span>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
 
            <div className='buttonstyle'>
              <button
                onClick={() => setShowPopup(false)}
                className="formButtonStop"
              >
                Cancel
              </button>
              <button
                onClick={handleRenameSubmit}
                className="formButtonDownload"
              >
                Confirm
              </button>
            </div>
            <div>
                <span className='create-new-folder-ErrorMsg'>
                    {renameErrMsg}
                </span>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
 
export default BulkRenamePopup;